import { useDeviceType } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getChatDates } from './getChatDates';
import { trackModalOpen } from './tracking';
import { closeChatModal } from '../../actions/chatModal';
import { selectIsDesktopListingVisible } from '../../selectors/desktopListing';
import { selectJsonQuery } from '../../selectors/filters';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { getAnalyticsPageType } from '../../utils/analytics';
import { buildChatSrc } from '../../utils/buildChatSrc';

export interface IChatView {
  isOpen: boolean;
  src: string | null;
  onOpen(): void;
  onClose(): void;
}

export function useChatView(): IChatView {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();

  const isOpen = useSelector((state: IApplicationState) => state.chatModal.isOpen);
  const gaLabel = useSelector((state: IApplicationState) => state.chatModal.gaLabel);
  const defaultMessage = useSelector((state: IApplicationState) => state.chatModal.defaultMessage);
  const offer = useSelector((state: IApplicationState) => state.chatModal.offer);
  const jsonQuery = useSelector(selectJsonQuery);
  const isDesktopListingVisible = useSelector(selectIsDesktopListingVisible);

  const dates = getChatDates(jsonQuery);
  const pageType = getAnalyticsPageType({
    deviceType,
    isDesktopListingVisible,
  });
  const src = offer ? buildChatSrc(offer, { gaLabel, dates, defaultMessage, pageType }) : null;

  const onClose = useCallback(() => {
    dispatch(closeChatModal());
  }, [dispatch]);

  const onOpen = useCallback(() => {
    trackModalOpen(gaLabel);
  }, [gaLabel]);

  return { isOpen, src, onClose, onOpen };
}
